import React from "react"
import { Flex, Box, HStack, Text, Heading } from "@chakra-ui/react"

export default function Item({ question, answer }) {
  return (
    <HStack spacing={6} align="start">
      <Box
        bg="primary.200"
        rounded="50%"
        maxH="34px"
        maxW="34px"
        minH="34px"
        minW="34px"
        mt={1}
      />
      <Flex flexDirection="column">
        <Heading fontSize="lg" fontWeight="medium" mb={2}>
          {question}
        </Heading>
        <Text>{answer}</Text>
      </Flex>
    </HStack>
  )
}
